import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-view" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_generator = _resolveComponent("game-generator")!
  const _component_playtable = _resolveComponent("playtable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.game.gameState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Cargando..."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.gameStarted)
            ? (_openBlock(), _createBlock(_component_game_generator, { key: 0 }))
            : (_openBlock(), _createBlock(_component_playtable, { key: 1 }))
        ], 64))
  ]))
}